import React, {createContext, useReducer} from 'react'
import {CartDetailReducer} from "../reducer/CartDetailReducer";

export const CartDetailContext = createContext()

const CartDetailContextProvider = (props) => {
    const state = {
        name: "",
        bags: [],
        packages: []
    }
    const [ viewModel, dispatch ] = useReducer(CartDetailReducer, state)
    return (
        <CartDetailContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </CartDetailContext.Provider>
    )
}

export default CartDetailContextProvider


// WEBPACK FOOTER //
// ./src/components/cartDrillDown/context/CartDetailContext.js